import {useRef} from 'react';

import {SearchRequest} from '../../../api/types';
import {AcademicYearSearchFormProps} from '../../../components/academic-year-search-form';
// eslint-disable-next-line max-len
import {PaginationOptions, TableRef} from '../../../components/academic-year-search-form/components';
import {SearchRequestOptions} from '../../../hooks/queries/use-query-school-academic-years-search';
import {createColumns, transformRegionFilterFromSchools} from '../utils';
import {useSchoolAcademicYearsSearch} from './use-academic-years-search';

export const useSearchTable = (): AcademicYearSearchFormProps => {
    const {
        isQueryEnabled,
        searchRequestOptions,
        isError,
        isLoading,
        isFetching,
        isPreviousData,
        onSearch,
        data
    } = useSchoolAcademicYearsSearch();

    const columns = createColumns();
    const regions = transformRegionFilterFromSchools(data?.schools || []);
    const tableRef = useRef<TableRef>(null);

    const handleSearchRequest = (options: SearchRequestOptions) => {
        onSearch(options);
    };

    const handleSetRegionFilter = (filterValue: string) => {
        if (!tableRef?.current) return;
        tableRef.current.setFilter('Region', filterValue);
    };

    const handleSetRegionOrSchoolSettingFilter = (filterValue: string) => {
        if (!tableRef?.current) return;
        tableRef.current.setFilter('Type', filterValue);
    };

    const handlePaginationChange = (options: PaginationOptions) => {
        handleSearchRequest({
            ...searchRequestOptions,
            params: {
                ...searchRequestOptions.params,
                PageSize: options.pageSize,
                PageIndex: options.pageIndex
            }
        });

    };

    const handleSearch = (request: SearchRequest) => {
        handleSearchRequest({
            ...searchRequestOptions,
            request: request
        });
    };

    return {
        onSetSettingFilter: handleSetRegionOrSchoolSettingFilter,
        onSetRegionFilter: handleSetRegionFilter,
        onPaginationChange: handlePaginationChange,
        onSearch: handleSearch,
        isVisible: isQueryEnabled,
        regions,
        tableRef,
        columns,
        isError,
        isLoading,
        isPreviousData,
        isFetching,
        data,
        pageSize: searchRequestOptions.params.PageSize,
        pageIndex: searchRequestOptions.params.PageIndex
    };
};
